
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { getTheme } from 'vcc-ui';
export const responsiveProps = {
  alignContent: true,
  alignItems: true,
  alignSelf: true,
  aspectRatio: true,
  columnGap: true,
  display: true,
  flex: true,
  flexBasis: true,
  flexDirection: true,
  flexGrow: true,
  flexShrink: true,
  flexWrap: true,
  gap: true,
  height: true,
  justifyContent: true,
  margin: true,
  marginBottom: true,
  marginLeft: true,
  marginRight: true,
  marginTop: true,
  maxHeight: true,
  maxWidth: true,
  minHeight: true,
  minWidth: true,
  order: true,
  padding: true,
  paddingBottom: true,
  paddingLeft: true,
  paddingRight: true,
  paddingTop: true,
  rowGap: true,
  textAlign: true,
  width: true
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Spacer = makeShortcode("Spacer");
const layoutProps = {
  responsiveProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "responsive-design-and-media-queries"
    }}>{`Responsive design and media queries`}</h1>
    <p>{`Web experiences should be built mobile first, customizing the experience for non-mobile users with media queries.`}</p>
    <h2 {...{
      "id": "a-simple-media-query"
    }}>{`A simple media query`}</h2>
    <p>{`You can specify any CSS valid media query as an object key, like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<View
  extend={{
    '@media (min-device-pixel-ratio: 2)': {
      color: 'red',
    },
  }}
>
  Helo Retina Red!
</View>
`}</code></pre>
    <h2 {...{
      "id": "included-media-queries-and-breakpoints"
    }}>{`Included media queries and breakpoints`}</h2>
    <p>{`The default media queries are available as keys on any `}<inlineCode parentName="p">{`extend`}</inlineCode>{` style block:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<View
  extend={{
    color: 'red'
    fromM: {
      color: 'green'
    },
    fromL: {
      color: 'blue'
    },
  }}
>
  Hello Responsive!
</View>
`}</code></pre>
    <p>{`They are also available on the theme:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const { breakpoints } = useTheme();
// breakpoints.fromM === '@media (min-width: 480px)' etc
`}</code></pre>
    <p>{`For the common use case of setting a layout property to different values depending on the breakpoint, you can use an object with breakpoints as a value, or an array representing the same breakpoints.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true expanded=true",
        "live": "true",
        "expanded": "true"
      }}>{`<View
  extend={{
    backgroundColor: 'background.secondary',
    borderColor: 'ornament.border',
    borderWidth: 1,
    borderStyle: 'solid',
    padding: 8,
    width: {
      default: 100,
      fromM: 200,
      fromL: 300,
      fromXL: 400,
    },
  }}
>
  <Text>object breakpoints</Text>
</View>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true expanded=true",
        "live": "true",
        "expanded": "true"
      }}>{`<View
  extend={{
    backgroundColor: 'background.secondary',
    borderColor: 'ornament.border',
    borderWidth: 1,
    borderStyle: 'solid',
    padding: 8,
    width: [100, 200, 300, 400],
  }}
>
  <Text>array breakpoints</Text>
</View>
`}</code></pre>
    <p>{`The following CSS properties accept responsive object or array values:`}</p>
    <code style={{
      whiteSpace: 'pre-line'
    }}>{Object.keys(responsiveProps).sort().join('\n')}</code>
    <Spacer size={4} mdxType="Spacer" />
    <h3 {...{
      "id": "all-media-queries"
    }}>{`All media queries`}</h3>
    <table>
  <tbody>
  <tr>
    <th>key</th>
    <th>media query</th>
  </tr>
  {Object.entries(getTheme({
          variant: 'light'
        }).breakpoints).map((key, value) => <tr key={key}>
      <td>{key}</td>
      <td>{value}</td>
    </tr>)}
  </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;